import React, { useRef, useState } from 'react'
import SafeAxios from '../../data/safe-axios.js'
import {
  isInvestor,
  isInstitutional,
} from '../../authentication/authentication-manager.js'
import DesktopNavigationSearchView from './DesktopNavigationSearchView.jsx'
import MobileNavigationSearchView from './MobileNavigationSearchView.jsx'

let cancelToken = null
export default function NavigationSearch({ name, action, isMobile = false }) {
  const [searchText, setSearchText] = useState('')
  const [autoCompleteData, setAutoCompleteData] = useState([])
  const [autoCompleteIndex, setAutoCompleteIndex] = useState(-1)
  const formRef = useRef()
  const siteName = isInvestor()
    ? 'cti-inv'
    : isInstitutional()
      ? 'cti-inst'
      : 'cti-adv'

  const resetAutoComplete = () => {
    setAutoCompleteData([])
    setAutoCompleteIndex(-1)
  }

  const getSearchSuggestions = (search) => {
    if (cancelToken) {
      cancelToken?.cancel()
    }
    cancelToken = SafeAxios.CancelToken.source()
    if (search.trim().length > 2 && search.split(' ').length < 2) {
      const url = `/api/${siteName}/autocomplete/${search}?count=5&field=text`
      SafeAxios.get(url, {
        cancelToken: cancelToken.token,
      })
        .then((response) => {
          setAutoCompleteData(response.data)
          setAutoCompleteIndex(-1)
        })
        .catch((error) => {
          if (SafeAxios.isCancel(error)) {
            return
          } else {
            throw error
          }
        })
    } else {
      resetAutoComplete()
    }
  }

  const onSearchChange = ({ currentTarget }) => {
    const value = currentTarget.value
    setSearchText(value)
    getSearchSuggestions(value)
  }

  const sanitizeInput = (input) => {
    return input.replaceAll('%22', '').replaceAll(' ', '+')
  }

  const onClickAutoCompItem = (item) => {
    setSearchText(item)
    setTimeout(() => {
      window.location = `${action}?search=${sanitizeInput(
        encodeURIComponent(item)
      )}`
    }, 100)
  }

  const onClickClearSearch = () => {
    if (cancelToken) {
      cancelToken?.cancel()
    }
    setSearchText('')
    resetAutoComplete()
  }

  const onKeyUpSearch = (event) => {
    const dataLength = autoCompleteData?.length
    if (!dataLength) {
      return
    }
    // UP ARROW
    if (event.keyCode === 38) {
      if (autoCompleteIndex < 1) {
        setAutoCompleteIndex(dataLength - 1)
        setSearchText(autoCompleteData[dataLength - 1])
      } else {
        setAutoCompleteIndex(autoCompleteIndex - 1)
        setSearchText(autoCompleteData[autoCompleteIndex - 1])
      }
    }
    // DOWN ARROW
    else if (event.keyCode === 40) {
      if (autoCompleteIndex === dataLength - 1) {
        setAutoCompleteIndex(0)
        setSearchText(autoCompleteData[0])
      } else {
        setAutoCompleteIndex(autoCompleteIndex + 1)
        setSearchText(autoCompleteData[autoCompleteIndex + 1])
      }
    }
  }

  const Component = isMobile
    ? MobileNavigationSearchView
    : DesktopNavigationSearchView

  return (
    <Component
      {...{
        name,
        action,
        searchText,
        onSearchChange,
        onSearchLeave: resetAutoComplete,
        onKeyUpSearch,
        onClickClearSearch,
        autoCompleteData,
        autoCompleteIndex,
        onClickAutoCompItem,
        ref: formRef,
      }}
    />
  )
}
